import React, { useState } from "react";

import { BlobServiceClient } from '@azure/storage-blob';
import { v4 as uuid } from 'uuid';
import { VscChromeClose } from "react-icons/vsc";
import * as XLSX from "xlsx";
import toast from 'react-hot-toast';
import "react-toastify/dist/ReactToastify.css";
import Papa from "papaparse";
import axios from "axios";
// import * as ExcelJS from 'exceljs';

import Upload from "../../../assets/upload.png";
import EmptyFolder from "../../../assets/Empty Folder.png";
import Xls from "../../../assets/XLS.png";
import loadingGif from "../../../assets/loading.gif";
import csvIcon from "../../../assets/csv.svg";
// import Loader from "../../../assets/Mask Group 6.svg";
import CsvPreview from "../../ReUseable/CsvPreview";
import SheetLists from "../../ReUseable/SheetLists";
import WorkflowFilePreview from "./WorkflowFilePreview";
import DataValidation from "../DataValidation/DataValidation";
import MappingTable from "../Mapping/MappingTable";
import { useAuth } from "../../../hooks/useAuth";
import { API } from "../../../global";
import DestinationTables from "../DestinationTables/DestinationTables";

const Preview = (props) => {
  const { setPreviewStepper, setDataValidationStepper, setDestinationTableStepper, setAutoMappingStepper, setReviewStepper, setDestinationStepper, setDeleteModalOpen, deleteModalOpen } = props;

  const [sname, setSname] = useState(false);
  const [sheet, setSheet] = useState([]);
  const [sheetData, setSheetData] = useState(null);
  const [SheetNames, setSheetNames] = useState(null);
  const [file_type, setFile_type] = useState("");
  const [file_name, setFile_name] = useState("");
  const acceptableFileName = ["xlsx", "xls", "csv"];
  const [sheetPreview, setSheetPreview] = useState(false);
  //csv
  const [csvTable, setCsvTable] = useState(false);
  const [values, setValues] = useState([]);
  const [tableRows, setTableRows] = useState([]);
  const [tableShow, setTableShow] = useState(false);

  const [checkAll, setCheckAll] = useState(false);
  const [checkboxes, setCheckboxes] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [skipDataValidation, setSkipDataValidation] = useState(false);
  const [noFileSelected, setNoFileSelected] = useState(true);
  const [fileName, setFileName] = useState(false);

  const [currentIndex, setCurrentIndex] = useState(0);

  const [loading, setLoading] = useState(false);
  const [dataValidation, setDataValidation] = useState(false);
  const [autoMapping, setAutoMapping] = useState(false);
  const [review, setReview] = useState(false);
  const [excelFile, setExcelFile] = useState();
  const { user } = useAuth();
  const [showDestinationTables, setShowDestinationTables] = useState(false);
  const [fileUrl, setFileUrl] = useState("");
  const [destinationTables, setDestinationTables] = useState([]);
  const [apiLoading, setApiLoading] = useState(false);
  const [selectedDestinationTables, setSelectedDestinationTables] = useState([]);
  const [showCsvIcon, setShowCsvIcon] = useState(false);

  const handleForwardClick = () => {
    if (currentIndex < selectedValues.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handleBackwardClick = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const displayedElements = selectedValues.slice(
    currentIndex,
    currentIndex + 7
  );

  const handleCheckboxChange = (value, checked) => {
    if (checked) {
      setCheckboxes([...checkboxes, value]);
    } else {
      setCheckboxes(checkboxes.filter((item) => item !== value));
    }
  };

  const handleSubmit = () => {
    if (checkboxes.length === SheetNames.length) {
      setSelectedValues(checkboxes);
    } else {
      setSelectedValues(checkboxes);
    }
    setSheetPreview(true);
    setTableShow(true);
    setSname(false);
    setSheet(checkboxes[0]);
  };

  const createPipeline = async (file, ft) => {
    let userFile = await uploadFile(file, ft);
    setFileUrl(userFile);
    const config = {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("auth_token")}`
      }
    };
    const fileDetails = {
      pipelineId: localStorage.getItem("pipelineId"),
      source: true,
      sourceType: "file",
      fileUrl: userFile,
    }
    const res = await axios.post(`${API}/pipelines/update`, fileDetails, config);
    if (res.data.success) {
    } else {
      toast.error(res.data.error.msg);
    }
  }

  const handleFileUpload = async (e) => {
    setNoFileSelected(false);
    setLoading(true);
    const file = e.target.files[0];
    const fileName = file.name;
    setFile_name(fileName);
    const ft = fileName.split(".").pop().toLowerCase();
    setFile_type(ft);
    if (!acceptableFileName.includes(ft)) {
      toast.warning("Invalid File Type");
      return;
    }
    if (ft === "csv") {
      setTableShow(true);
      setShowCsvIcon(true);
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: async function (results) {
          const rowsArray = [];
          const valuesArray = [];
          results.data.map((d) => rowsArray.push(Object.keys(d)));
          results.data.map((d) => valuesArray.push(Object.values(d)));
          setTableRows(rowsArray[0]);
          localStorage.setItem("header", JSON.stringify(rowsArray[0]));
          setValues(valuesArray);
          localStorage.setItem("filename", JSON.stringify(fileName));
        },
      });
      await createPipeline(file, ft);
      setCsvTable(true);
      setSname(false);
      setLoading(false);
      setPreviewStepper(true);
    }

    if (ft === "xls" || ft === "xlsx") {
      setExcelFile(file);
      setFileName(true);
      const data = await file.arrayBuffer();
      const wb = XLSX.read(data);
      setSheetNames(wb.SheetNames);
      try {
        let mySheetData = {};
        for (let j = 0; j < wb.SheetNames.length; j++) {
          let sheetName = wb.SheetNames[j];
          const worksheet = wb.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet, {
            blankrows: "",
            header: 1,
            defval: "",
            cellDates: true,// Enable date parsing            
            raw: false
          });
          mySheetData[sheetName] = jsonData.map(row => {
            // Convert date string to Date object for all date values
            for (const key in row) {
              if (Object.prototype.hasOwnProperty.call(row, key) && row[key] instanceof Date) {
                row[key] = new Date(row[key]);
              }
            }
            return row;
          });
        }
        await createPipeline(file, ft);
        setSheetData(mySheetData);
        setPreviewStepper(true);
        setSname(true);
        setLoading(false);
      }
      catch (error) {
        console.error("Error processing the file:", error);
      }
    }

  };

  const clearStates = () => {
    setSname(false);
    setNoFileSelected(true);
    setSheetPreview(false);
    setFileName(false);
    setReview(false);
    setCsvTable(false);
    setTableShow(false);
    setCheckboxes([]);
    setCheckAll(false);
    setDataValidation(false);
    setAutoMapping(false);
    setSkipDataValidation(false);
    setPreviewStepper(false);
    setDataValidationStepper(false);
    setAutoMappingStepper(false);
    setReviewStepper(false);
    setDestinationStepper(false);
    setDestinationTableStepper(false);
    setShowDestinationTables(false);
    setLoading(false);
    setSelectedDestinationTables([]);
    // setShowUploadFile(false);
    // setShowCreateWorkflow(false);
  };

  const handleSingleSheet = (e) => {
    setSheetPreview(true);
    setTableShow(true);
    setSname(false);
    setFileName(false);
  };

  const handleTablePreviewContinue = async () => {
    setFileName(false);
    setSname(false);
    setTableShow(false);
    setSheetPreview(false);
    setCheckAll(false);
    setCsvTable(false);
    setDataValidationStepper(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("auth_token")}`
      }
    };
    const fileDetails = {
      pipelineId: localStorage.getItem("pipelineId"),
      preview: true
    }
    const res = await axios.post(`${API}/pipelines/update`, fileDetails, config);
    if (!res.data.success) {
      toast.error(res.data.error.msg);
    }
    if (skipDataValidation) {
      getDestinationTables();
    }
    else {
      setDataValidation(true);
    }
  };

  const handleSelectAll = (checked) => {
    setCheckAll(!checkAll);
    if (checked) {
      setCheckboxes(SheetNames);
    } else {
      setCheckboxes([]);
    }
  };

  const uploadFile = async (myFile, fileType) => {
    const blobServiceClient = new BlobServiceClient(`${localStorage.getItem('sas_url')}`);
    const containerName = user?.current_workspace._id.toString().toLowerCase();
    const containerClient = blobServiceClient.getContainerClient(containerName);
    const options = {
      blobHTTPHeaders: {
        blobContentType: fileType === "csv" ? "text/csv" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      }
    };

    try {
      const fileName = uuid() + "." + fileType;
      const blockBlobClient = containerClient.getBlockBlobClient(fileName);
      await blockBlobClient.uploadData(myFile, options);
      return blockBlobClient.url;
    } catch (error) {
      console.error('Error uploading File:', error);
    }
  };

  const handleMapping = async () => {
    setDataValidation(false);
    setDataValidationStepper(true);
    setAutoMappingStepper(true);
    setDeleteModalOpen(false);
    try {
      setAutoMapping(true);
      const fileDetails = {
        userFile: fileUrl,
        table: selectedDestinationTables,
        pipelineId: localStorage.getItem("pipelineId")
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("auth_token")}`
        }
      };
      const res = await axios.post(`${API}/agent/map`, fileDetails, config);
      if (res.data.success) {
        localStorage.setItem(`MAPPING_API_RES`, JSON.stringify(res.data.result));
        setAutoMapping(false);
        setReview(true);
        setReviewStepper(true);
      } else {
        toast.error(res.data.error.msg);
        setAutoMapping(false);
        setAutoMappingStepper(false);
        setShowDestinationTables(true);
      }
    } catch (error) {
      setAutoMapping(false);
      setAutoMappingStepper(false);
      setShowDestinationTables(true);
      toast.error('It appears that there is an error in the backend API. Please ensure that you have prepared the system before proceeding with your workflow.');
    }
  }

  const handleDataValidationContinue = () => {
    setDataValidationStepper(true);
    setDataValidation(false);
    setDestinationTableStepper(true);
    setDeleteModalOpen(false);
    getDestinationTables();
  }

  const handleDestinationTableContinue = () => {
    setShowDestinationTables(false);
    setFileName(false);
    setSname(false);
    setTableShow(false);
    setSheetPreview(false);
    setCheckAll(false);
    setCsvTable(false);
    setDataValidationStepper(true);
    setDestinationTableStepper(true);
    setAutoMappingStepper(true);
    setAutoMapping(true);
    handleMapping();
  }

  const handleBackFromDestinationTables = () => {
    setShowDestinationTables(false);
    setDestinationTableStepper(false);
    setDataValidation(true);
    setDataValidationStepper(true);
  }

  const getDestinationTables = async () => {
    try {
      setApiLoading(true);
      const fileDetails = {
        userFile: fileUrl,
        pipelineId: localStorage.getItem("pipelineId")
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("auth_token")}`
        }
      };
      const res = await axios.post(`${API}/agent/table`, fileDetails, config);
      if (res.data.success) {
        setDestinationTables(res.data.result);
        setShowDestinationTables(true);
        setDestinationTableStepper(true);
        setApiLoading(false);
      } else {
        toast.error(res.data.error.msg);
        if (skipDataValidation) {
          setTableShow(true);
          if (file_type === "csv") {
            setCsvTable(true);
          } else if (file_type === "xlsx" || "xls") {
            setSheetPreview(true);
          }
          setApiLoading(false);
          setDataValidationStepper(false);
        } else {
          setDataValidation(true);
          setDataValidationStepper(true);
        }
        setSkipDataValidation(false);
        setDestinationTableStepper(false);
      }
    } catch (error) {
      setApiLoading(false);
      if (skipDataValidation) {
        setTableShow(true);
        if (file_type === "csv") {
          setCsvTable(true);
        } else if (file_type === "xlsx" || "xls") {
          setSheetPreview(true);
        }
        setApiLoading(false);
        setDataValidationStepper(false);
      } else {
        setDataValidation(true);
        setDataValidationStepper(true);
      }
      setSkipDataValidation(false);
      setDestinationTableStepper(false);
      toast.error('It appears that there is an error in the backend API. Please ensure that you have prepared the system before proceeding with your workflow.');
    }
  }

  return (
    <>
      <div className="my-10 flex gap-[25px]">
        {tableShow && (
          <div className="flex flex-col">
            <div className="font-medium text-lg">Upload</div>
            <div className="z-10">
              <div className="flex mt-5 justify-between p-5 h-20 gap-[90px] bg-white rounded-lg hover:w-fit drop-shadow-[0_0_10px_#00000029] overflow-hidden transition-all w-20 delay-[200ms]">
                <div className='flex gap-5 items-center'>
                  {showCsvIcon ? (
                    <img src={csvIcon} alt="csv" className='w-10 h-10' />
                  ) : (
                    <img src={Xls} alt="xls" className='w-10 h-10' />
                  )}
                  <div className="flex flex-col text-xs text-lite-black font-semibold">
                    {file_name}
                    <span>{`text/${file_type}`}</span>
                  </div>
                </div>
                <div className='flex items-center' onClick={() => clearStates()}>
                  <VscChromeClose color="#707070" fontSize="15px" className="cursor-pointer" />
                </div>
              </div>
            </div>
          </div>
        )}

        {fileName && (
          <div className="flex flex-col">
            <div className="font-medium text-lg">Upload</div>
            <div className="p-5 flex items-center gap-9 max-w-xs bg-white rounded-lg shadow-[0px_0px_10px_0px_rgba(0,0,0,0.16)] font-semibold mt-5 text-lite-black text-xs z-10">
              <span>
                <img src={Xls} alt="xls" className='w-10 h-10 object-cover' />
              </span>
              <div className="flex flex-col text-xs">
                <span>{file_name}</span>
                <span>{`text/${file_type}`}</span>
              </div>
              <span onClick={() => clearStates()}>
                <VscChromeClose color="#707070" fontSize="15px" className='cursor-pointer' />
              </span>
            </div>
          </div>
        )}

        {noFileSelected && (
          <div className="flex flex-col font-medium text-lg">
            <div className="mb-5">Upload</div>
            <div className="flex flex-col items-center border-dashed border border-lite-grey-5 rounded-xl py-[30px] px-[45px]">
              <label htmlFor="files" className="flex justify-center mb-2 cursor-pointer">
                <img src={Upload} alt="upload" />
              </label>
              <input
                id="files"
                type="file"
                accept=".csv,.xlsx,.xls"
                onChange={handleFileUpload}
                className="hidden" />
              <div className="mb-1">Click to upload</div>
              <div className="font-regular text-xs">
                Please upload .xlsx or .csv file. The maximum size of file is
                1 GB
              </div>
            </div>
          </div>
        )}

        <div className="flex-1 font-medium text-lg">
          {loading && (
            <div className="px-5 border-l-[1px] border-[#CCCCCC] h-[280px]">
              <div>Preview</div>
              <div className="flex justify-center items-center mt-10 flex-col">
                <div className="flex flex-col justify-center items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="50" height="65" viewBox="0 0 50 65">
                    <defs>
                      <clipPath id="clip-path">
                        <path id="Path_15" data-name="Path 15" d="M95.487,19.043A4.471,4.471,0,0,1,91,14.6V0H68.051A7.025,7.025,0,0,0,61,6.982V58.018A7.025,7.025,0,0,0,68.051,65h35.9A7.025,7.025,0,0,0,111,58.018V19.043ZM71.513,45.7h9.323a1.9,1.9,0,1,1,0,3.809H71.513a1.9,1.9,0,1,1,0-3.809ZM69.59,37.451a1.914,1.914,0,0,1,1.923-1.9H99.718a1.9,1.9,0,1,1,0,3.809H71.513A1.914,1.914,0,0,1,69.59,37.451ZM99.718,25.391a1.9,1.9,0,1,1,0,3.809H71.513a1.9,1.9,0,1,1,0-3.809Z" transform="translate(857 340)" fill="#bcbcbc" />
                      </clipPath>
                      <linearGradient id="linear-gradient" x1="0.067" y1="1" x2="1" gradientUnits="objectBoundingBox">
                        <stop offset="0" stopColor="#00c8ad" />
                        <stop offset="1" stopColor="#0078c5" />
                      </linearGradient>
                    </defs>
                    <g id="Mask_Group_6" data-name="Mask Group 6" transform="translate(-918 -340)" clipPath="url(#clip-path)">
                      <rect id="Rectangle_105" data-name="Rectangle 105" width="50" height="65" transform="translate(918 340)" fill="url(#linear-gradient)" />
                    </g>
                  </svg>
                  {/* <img src={loadingGif} alt="loading" className="w-[50px] h-[65px]" /> */}
                  {/* <img src={Loader} alt="loader" /> */}
                  <h5 className="mt-5">Analysing....</h5>
                </div>
              </div>
            </div>
          )}

          {csvTable && (
            <div className="z-0 absolute left-44 right-5 pb-5">
              <CsvPreview
                tableRows={tableRows}
                values={values}
                file_name={file_name}
                handleContinue={handleTablePreviewContinue}
                handleBack={clearStates}
                setSkipDataValidation={setSkipDataValidation}
                skipDataValidation={skipDataValidation}
                showSkipValidation={true}
              />
            </div>
          )}

          {sname && (
            <SheetLists checkboxes={checkboxes} handleSubmit={handleSubmit}
              handleSingleSheet={handleSingleSheet} handleSelectAll={handleSelectAll}
              handleCheckboxChange={handleCheckboxChange} setSheet={setSheet} sheetNames={SheetNames}
              checkAll={checkAll} setSheetPreview={setSheetPreview} setSname={setSname} excel={true} />
          )}

          {sheetPreview && (
            <div className="z-0 absolute left-44 right-5 pb-5">
              <WorkflowFilePreview
                handleContinue={handleTablePreviewContinue}
                setCheckboxes={setCheckboxes}
                sheet={sheet} sheetData={sheetData}
                selectedValues={selectedValues}
                checkboxes={checkboxes} setSheet={setSheet}
                displayedElements={displayedElements}
                handleBackwardClick={handleBackwardClick}
                currentIndex={currentIndex}
                handleForwardClick={handleForwardClick}
                skipDataValidation={skipDataValidation}
                setSkipDataValidation={setSkipDataValidation}
                setSheetPreview={setSheetPreview}
                setSname={setSname}
                setPreviewStepper={setPreviewStepper}
                setTableShow={setTableShow}
                checkAll={checkAll}
                setCheckAll={setCheckAll} setFileName={setFileName} sheetNames={SheetNames}
              />
            </div>
          )}

          {showDestinationTables && (
            <DestinationTables
              destinationTables={destinationTables}
              selectedDestinationTables={selectedDestinationTables}
              setSelectedDestinationTables={setSelectedDestinationTables}
              handleContinue={handleDestinationTableContinue}
              handleBackFromDestinationTables={handleBackFromDestinationTables}
            />
          )}

          {dataValidation && (
            <DataValidation sheet={sheet} setDataValidationStepper={setDataValidationStepper}
              clearStates={clearStates} sheetData={sheetData} fileName={file_name} excelFile={excelFile}
              handleContinue={handleDataValidationContinue} deleteModalOpen={deleteModalOpen} setDeleteModalOpen={setDeleteModalOpen}
              selectedValues={selectedValues} currentIndex={currentIndex} setSheet={setSheet} sheetNames={SheetNames}
              setDataValidation={setDataValidation} setSheetPreview={setSheetPreview} displayedElements={displayedElements}
              setTableShow={setTableShow} handleBackwardClick={handleBackwardClick} handleForwardClick={handleForwardClick} checkboxes={checkboxes}
              setCsvTable={setCsvTable} fileType={file_type} fileUrl={fileUrl} csvColumns={tableRows}
            />
          )}

          {autoMapping && (
            <div className="flex justify-center items-center mt-28 flex-col">
              <div className="flex flex-col justify-center items-center">
                <img src={loadingGif} alt="loading" className="w-[50px] h-[65px]" />
                <h5 className="mt-5">Analysing....</h5>
              </div>
            </div>
          )}

          {apiLoading && (
            <div className="flex justify-center items-center mt-28 flex-col">
              <div className="flex flex-col justify-center items-center">
                <img src={loadingGif} alt="loading" className="w-[50px] h-[65px]" />
                <h5 className="mt-5">Loading....</h5>
              </div>
            </div>
          )}

          {review ?
            <MappingTable clearStates={clearStates} sheet={sheet} sheetData={sheetData} selectedValues={selectedValues}
              checkboxes={checkboxes} setSheet={setSheet} displayedElements={displayedElements} handleBackwardClick={handleBackwardClick}
              currentIndex={currentIndex} setDataValidation={setDataValidation} setAutoMappingStepper={setAutoMappingStepper}
              handleForwardClick={handleForwardClick} setReview={setReview} setReviewStepper={setReviewStepper}
              sheetNames={SheetNames} setDataValidationStepper={setDataValidationStepper}
              setSkipDataValidation={setSkipDataValidation} setDeleteModalOpen={setDeleteModalOpen} excelFile={excelFile}
              setDestinationStepper={setDestinationStepper}
              fileUrl={fileUrl} csvColumns={tableRows}
              setShowDestinationTables={setShowDestinationTables}
              setSelectedDestinationTables={setSelectedDestinationTables}
            />
            : ""}

          {noFileSelected ?
            <div className="px-5 border-l-[1px] border-[#CCCCCC] h-[280px]">
              <div>Preview</div>
              <div className="mt-2 flex flex-col">
                <div className="flex flex-col items-center p-5">
                  <div className="flex justify-center mb-2 w-fit">
                    <img src={EmptyFolder} alt="folder" />
                  </div>
                  <div className="mb-1">No data file has been selected</div>
                  <div className="text-[11px]">
                    To preview data specific data you would like to ingest
                    into a dataset within platform
                  </div>
                </div>
              </div>
            </div> : ''}
        </div>
      </div>

      {/* {noFileSelected && !user?.current_workspace?.is_trained && (
        <div className="bg-[#D4F1FF] border border-teal rounded-xl p-5 my-10 mx-12 text-lite-black">
          <div className="text-lg font-medium">Preparation</div>
          <div className="text-sm font-normal mt-2.5">
            {user?.current_workspace?.is_train_data_uploaded ? (
              <>
                Your train data is uploaded. Training is in progress. Data validation and Auto Mapping accuracy will improve once training is completed.
              </>
            ) : (
              <>
                You have not trained any target data. Data validation and Auto Mapping accuracy will improve once training is completed.
              </>
            )}
          </div>
        </div>
      )} */}
    </>
  );
};

export default Preview;